<script>
    import FormModal from '../../components/modals/FormModal.vue';
    import axios from 'axios';
    import { Inertia } from '@inertiajs/inertia';
    
    export default {
        components: {FormModal},
		props: {
            userProfilePhoto: String,
            hasProfilePhoto: Boolean,
            userDetails: Object,
        },
        data() {
            return {
                isShowProfileModal: false,
                isProfileButtonLoading: false, 
                profileModalTitle: null,
                profileSubmitButtonText: null,
                croppedImg: null,
                isSelectedProfilePhoto: false,
                isUploadDisabled: true,
                fileName: null
            }
        },
        methods: {
            showProfileModal() {
                this.profileModalTitle = 'Change Profile Picture';
                this.profileSubmitButtonText = 'Upload';
                this.isShowProfileModal = true;
                this.isUploadDisabled = true;
                this.isSelectedProfilePhoto = this.hasProfilePhoto;
                const url = this.userProfilePhoto
                const imageName = url.substring(url.lastIndexOf('/') + 1);
                this.fileName = imageName;
                setTimeout(() => {
                    if (this.hasProfilePhoto) {
                        this.$refs.croppieRef.bind({
                            url: url
                        })
                        .then(() => {
                            this.isUploadDisabled = false
                        });
                    }
                }, 300)
            },
            handleProfilePhotoSubmit() {
                this.profileSubmitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`
                this.isProfileButtonLoading = true
                let options = {
                    type: 'blob',
                    size: 'original'
                };
                this.$refs.croppieRef.result(options, output => {
                    this.croppedImg = output;
                })
                .then(() => {
                    const formData = new FormData();
                    const profileId = this.userDetails?.check_user_photo?.user_profile_photo?.id;
                    formData.append('profilePhoto', this.croppedImg);
                    formData.append('profilePhotoId', profileId);
                    formData.append('profileImageName', this.fileName);
                    axios.post(route('tp-profile-update-photo'), formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.hideProfileModal()
                            Inertia.reload();
                            this.$toastr.s(response.data.message)
                        } else {
                            this.profileSubmitButtonText = 'Upload'
                            this.isProfileButtonLoading = false
                            this.$toastr.e(response.data.message)
                        }
                    })
                    .catch(err => {
                        if (err.response.status == 422) {
                            const errorKeys = Object.keys(err?.response?.data?.errors)
                            errorKeys.forEach((key, index) => {
                                setTimeout(() => {
                                    this.$toastr.e(err?.response?.data?.errors[key][0]);
                                }, index * 300)
                            }); 
                        } else {
                            this.$toastr.e('Something went wrong!')
                        }
                        this.profileSubmitButtonText = 'Upload'
                        this.isProfileButtonLoading = false
                    })
                });
            },
            hideProfileModal() {
                this.isShowProfileModal = false;
                this.isSelectedProfilePhoto = false;
                this.isProfileButtonLoading = false;
                this.isUploadDisabled = false;
                this.profileModalTitle = 'Change Profile Picture';
                this.profileSubmitButtonText = 'Upload';
                this.croppedImg = null;
                this.fileName = null;
            },
            handleFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
            
                var reader = new FileReader();
                this.isSelectedProfilePhoto = true;
                reader.onload = e => {
                    this.$refs.croppieRef.bind({
                        url: e.target.result
                    })
                    .then(() => {
                        this.isUploadDisabled = false
                    });
                };
            
                reader.readAsDataURL(files[0]);
                this.fileName = files[0]?.name;
            }
        },       
  	}
</script>
<template>
    <div class="card">
        <div class="card-title p-3 pt-2 mb-0" style="margin-bottom: -30px !important;">Profile Picture</div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                            <img :src="userProfilePhoto" alt="profile-photo" class="avatar-xl rounded-circle img-thumbnail">
                        </div>
                        <div class="flex-grow-1 align-self-center">
                            <div class="text-muted">
                                <button @click="showProfileModal" class="btn btn-info">Change</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FormModal
            :isShow="isShowProfileModal"
            :title="profileModalTitle"
            :isButtonLoading="isProfileButtonLoading"
            :isShowSubmitButton="true"
            :isShowCancelButton="true"
            :isSubmitDisabled="isUploadDisabled"
            :clickSubmitButton="handleProfilePhotoSubmit"
            :submitButtonText="profileSubmitButtonText"
            @hideModal="hideProfileModal"
        >
            <vue-croppie 
                v-if="isSelectedProfilePhoto"
                ref="croppieRef" 
                :enableExif="true"
                :enableOrientation="true"
                :boundary="{ width: 250, height: 250}"
            >
            </vue-croppie>
            <div class="d-flex align-items-center justify-content-center">
                <input ref="uploadProfilePhoto" class="form-control" type="file" @change="handleFileChange" value="Choose a file" accept="image/*"/>
            </div>
        </FormModal>
    </div>
</template>